/* eslint-disable */
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { useDispatch, useSelector } from 'react-redux';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { toast } from 'react-toastify';
import countries from 'countries-list';
import Form from 'react-bootstrap/Form';
import { Select, InputLabel, FormControl } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';

// material Components
import { Card, Table, Box, TextField, Modal, Button, Tooltip, Alert, Checkbox, Stack } from '@mui/material';
import { TableRow, TableBody, TableCell, Container, Typography, TableContainer, TablePagination } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { IconButton, Snackbar, OutlinedInput } from '@mui/material';
import { MenuItem, ListItemText, Chip, TableHead } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import TabList from '@mui/lab/TabList';
import Tab from '@mui/material/Tab';

// React Icons
import BorderColorIcon from '@mui/icons-material/BorderColor';
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import ClearIcon from '@mui/icons-material/Clear';
import EmailIcon from '@mui/icons-material/Email';
import NoteIcon from '@mui/icons-material/Note';
import HistoryIcon from '@mui/icons-material/History';

// Redux slices
import { fetchGlobalData } from 'src/redux/globalData/globalDataSlice';
import { fetchEmailTemplate, resetGetInvoiceData } from '../../../redux/auth/authSlice';
import {
    setSearchQuery as setReduxSearchQuery,
    setSearchDropValue as setReduxSearchDropValue,
    setSelectedTabValue as setReduxSelectedTabValue,
    clearSearch
} from '../../../redux/globalData/usersSearchSlice';

// components
import { formatDate, getModalBoxStyle, loyaltyDropOptions, userDropOptions } from '../../../utils/commonFunc';
import TooltipWithCopy from '../../../components/TooltipWithCopy';
import { ListHead, ListToolbar } from '../../../sections/@dashboard/table';
import SearchNotFound from '../../../components/SearchNotFound';
import HoursModal from '../../../components/MonthlyHoursModal';
import { MultipleUsersPDF } from './MultipleUsersPDF';
import Scrollbar from '../../../components/Scrollbar';
import Page from '../../../components/Page';
import Loader from '../../../components/Loader';
import Iconify from '../../../components/Iconify';
import PermanentDeactivatedUser from './PermanentDeactivatedUser';

// ----------------------------------------------------------------------
const TABLE_HEAD = [
    { id: 'userId', label: 'User ID', alignRight: false },
    { id: 'name', label: 'Name', alignRight: false },
    { id: 'email', label: 'Email', alignRight: false },
    { id: 'totalPoints', label: 'Total Points', alignRight: false },
    { id: 'currentTier', label: 'Current Tier', alignRight: false },
    { id: 'actions', label: 'Actions', alignRight: false },
];

const deactivatedHead = [
    { id: 'userId', label: 'Id', alignRight: false },
    { id: 'name', label: 'Name', alignRight: false },
    { id: 'email', label: 'E-email', alignRight: false },
    { id: 'ssn', label: 'SSN', alignRight: false },
    { id: 'createdDate', label: 'Created Date', alignRight: false },
    { id: 'action', label: 'Action', alignRight: false },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator) {
    const stabilizedThis = array?.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });

    // if (query) {
    //   const searchRegex = new RegExp(escapeRegExp(query), "i");
    //   return filter(orgArray, (_row) =>
    //     Object.keys(_row).some((field) => {
    //       if (_row[field]) return searchRegex.test(_row[field].toString());
    //       return false;
    //     })
    //   );
    // }

    return stabilizedThis?.map((el) => el[0]);
}

export default function LoyaltyDashboard() {
    // Redux selectors for search state
    const searchQuery = useSelector((state) => state.usersSearch.searchQuery);
    const searchDropValue = useSelector((state) => state.usersSearch.searchDropValue);
    const selectedTabValue = useSelector((state) => state.usersSearch.selectedTabValue);

    const [selectedOption, setSelectedOption] = useState('');
    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState([]);
    const [personName, setPersonName] = useState([]);
    const [isSnackBarOpen, setIsSnackBarOpen] = useState(false);
    const [viewSurveyAnswers, setViewSurveyAnswers] = useState(false);
    const [surveyAnswers, setSurveyAnswers] = useState([]);
    const [surveyAnswersLoading, setSurveyAnswersLoading] = useState(false);
    const [isOpenModal, setIsOpenModal] = useState({
        bankDetails: false,
        sandEmail: false,
    });
    const [toggleNote, setToggleNote] = useState(false);
    const [autoHideDuration, setAutoHideDuration] = useState(3000);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertStatus, setAlertStatus] = useState('success');
    const [page, setPage] = useState(0);
    const [order, setOrder] = useState('desc');
    const [totalCount, setTotalCount] = useState(0);
    const [selected, setSelected] = useState([]);
    const [orderBy, setOrderBy] = useState('createdDate');
    // const [searchQuery, setSearchQuery] = useState(getselectedUser || '');
    const [rowsPerPage, setRowsPerPage] = useState(100);
    const [loading, setLoading] = useState(false);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [showEditModal, setShowEditModal] = useState(false);
    const [emailType, setemailType] = useState(null);
    // Add state for dynamic sorting
    const [sortOrder, setSortOrder] = useState('desc');
    const [sortColumn, setSortColumn] = useState('TotalPoints'); // Default to TotalPoints
    const currentYear = new Date().getUTCFullYear();
    const [toggleHourModal, settoggleHourModal] = useState(false);

    const [selectedYear, setSelectedYear] = useState(currentYear);
    const [getUserId, setGetUserId] = useState(0);

    const [incomeData, setincomeData] = useState({
        values: {},
        statusCode: null,
    });

    const [showUserDetails, setShowUserDetails] = useState(null);
    const [originalUsers, setOriginalUsers] = useState([]);
    const [isAllSelected, setAllSelected] = useState(false);
    const [templateData, setTemplateData] = useState({
        Subject: '',
        content: '<p></p>',
        templateFromName: '',
    });

    const [commentList, setcommentList] = useState([]);
    const [chooseBankName, setChooseBankName] = useState('');
    const [bankName, setBankName] = useState('');
    const [activateModal, setActivateModal] = useState({
        id: null,
        show: false,
        isActive: 'false',
    });
    const [permanentDeactivate, setpermanentDeactivate] = useState({
        userId: null,
        show: false,
    });
    const [accidentalReactivate, setaccidentalReactivate] = useState({
        userId: null,
        show: false,
    });
    const [notesContent, setNotesContent] = useState('');
    const [reasonForDeactivated, setreasonForDeactivated] = useState('');
    const [isReasonEmpty, setisReasonEmpty] = useState(false);
    const [isNotesContentEmpty, setIsNotesContentEmpty] = useState(false);
    const [openPDFModal, setOpenPDFModal] = useState(false);
    const [isSendLink, setisSendLink] = useState({
        id: null,
        show: false,
    });
    const [deleteUserModal, setDeleteUserModal] = useState({ show: false, userId: null });

    const [noteType, setNoteType] = useState('General'); // Dropdown value
    const [surveyNotes, setSurveyNotes] = useState([]);  // Survey notes/questions
    const [surveyLoading, setSurveyLoading] = useState(false);
    const [surveyRatings, setSurveyRatings] = useState({}); // { [SurveyQuestionId]: rating }
    const [surveySubmitted, setSurveySubmitted] = useState(false); // <-- Add this state
    const [customQuestion, setCustomQuestion] = useState('');
    const [customRating, setCustomRating] = useState(0);
    const [surveyReloaded, setSurveyReloaded] = useState(false);
    const isMobile = useMediaQuery('(max-width:600px)');
    const [selectedUserId, setSelectedUserId] = useState([]);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { emailTemplate, isLoading } = useSelector((data) => data.auth);
    const banksData = useSelector((state) => state?.globalData?.data?.banks);

    const {
        reset,
        watch,
        register,
        handleSubmit,
        resetField,
        formState: { errors },
    } = useForm();

    const ssnNumber = watch('ssn');
    const years = Array(currentYear - (currentYear - (currentYear - 2021)))
        .fill('')
        ?.map((v, idx) => currentYear - idx);

    const {
        reset: resetForm2,
        register: registerForm2,
        handleSubmit: handleSubmitForm2,
        formState: { errors: errorsForm2 },
    } = useForm();

    const {
        reset: resetForm3,
        register: registerForm3,
        handleSubmit: handleSubmitForm3,
        formState: { errors: errorsForm3 },
    } = useForm();

    useEffect(() => {
        dispatch(fetchEmailTemplate());
    }, []);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            fetchUsers();
        }, 600);
        return () => clearTimeout(timeoutId);
    }, [page, rowsPerPage, selectedTabValue, searchQuery, searchDropValue, sortOrder, sortColumn]);

    const { search } = useLocation();

    useEffect(() => {
        dispatch(fetchGlobalData());
    }, [dispatch]);

    const fetchUsers = async () => {
        try {
            setLoading(true);
            let URL;

            // Build base URL with dynamic sorting parameters
            const baseParams = `sortQuery=${sortOrder}&sortColumnName=${sortColumn}`;

            if (searchDropValue && searchQuery) {
                URL = `/adminloyaltydashboard?${baseParams}&PageSize=${rowsPerPage}&PageNumber=${page + 1
                    }&active=${selectedTabValue}&searchQuery=${searchQuery}&SearchColumn=${searchDropValue}`;
            } else if (searchQuery) {
                URL = `/adminloyaltydashboard?${baseParams}&PageSize=${rowsPerPage}&PageNumber=${page + 1
                    }&active=${selectedTabValue}&searchQuery=${searchQuery}`;
            } else {
                URL = `/adminloyaltydashboard?${baseParams}&PageSize=${rowsPerPage}&PageNumber=${page + 1
                    }&active=${selectedTabValue}`;
            }

            const res = await axios.get(URL);

            if (res?.status === 200) {
                setLoading(false);
                const users = res?.data?.response?.map((ele) => ({
                    ...ele,
                    isEdit: false,
                }));
                setOriginalUsers(users);

                // Set the total count for pagination
                setTotalCount(res.data.totalCount || 0);

                // Apply sorting and filtering
                const filteredRows = applySortFilter(users, getComparator(order, orderBy));
                setUsers(filteredRows);
                setFilteredUsers(filteredRows);
            }
        } catch (err) {
            if (err?.response?.data?.message === 'Something went wrong please try again after sometime.') {
                fetchUsers();
            } else {
                setUsers([]);
                setLoading(false);
            }
        }
    };

    const handleRequestSort = (event, property) => {
        // Map table column properties to API column names
        const columnMapping = {
            'userId': 'UserId',
            'name': 'FirstName',
            'email': 'Email',
            'totalPoints': 'TotalPoints',
            'currentTier': 'CurrentTier'
        };

        const apiColumnName = columnMapping[property] || 'UserId';

        // Determine sort order: if same column, toggle order; if different column, start with 'asc'
        const isAsc = orderBy === property && order === 'asc';
        const newOrder = isAsc ? 'desc' : 'asc';

        // Update local state for UI feedback
        setOrder(newOrder);
        setOrderBy(property);

        // Update API sorting state (this will trigger useEffect to refetch data)
        setSortOrder(newOrder);
        setSortColumn(apiColumnName);

        // Also update the search dropdown to match the selected column
        const reverseMapping = {
            'UserId': 'UserId',
            'FirstName': 'Name',
            'Email': 'Email',
            'TotalPoints': 'TotalPoints',
            'CurrentTier': 'CurrentTier'
        };

        const searchColumnValue = reverseMapping[apiColumnName];
        if (searchColumnValue) {
            dispatch(setReduxSearchDropValue(searchColumnValue));
        }
    };

    const selectAllClick = (isSelected, filteredUsers) => {
        if (isSelected) {
            const newSelecteds = filteredUsers?.map((n) => n.userId);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleSelectAllClick = (event) => {
        setAllSelected(event.target.checked);
        selectAllClick(event.target.checked, filteredUsers);
    };

    const handleDownloadSurvey = async () => {
        try {
            const response = await axios.get('/AdminNotesSurvey/export-survey?surveyType=5', {
                responseType: 'blob',
            });

            let fileName = 'survey-notes.csv';
            const disposition = response.headers['content-disposition'];
            if (disposition && disposition.indexOf('filename=') !== -1) {
                fileName = disposition.split('filename=')[1].replace(/"/g, '').trim();
            }

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            toast.error('Failed to download survey notes.');
        }
    };

    const handleClick = (event, id) => {
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected?.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
        }
        setSelected(newSelected);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setSelected(selected);
        setPage(0);
    };

    const handleFilter = (event) => {
        const newSearchQuery = event.target.value;
        dispatch(setReduxSearchQuery(newSearchQuery));
    };

    // Wrapper function to handle searchDropValue changes
    const handleSetSearchDropValue = (value) => {
        dispatch(setReduxSearchDropValue(value));

        // Map search column to sort column and update sorting
        const columnMapping = {
            'UserId': 'UserId',
            'Name': 'FirstName', // or could be 'LastName'
            'Email': 'Email',
            'TotalPoints': 'TotalPoints',
            'CurrentTier': 'CurrentTier'
        };

        // Set sort column based on selected search column
        if (columnMapping[value]) {
            setSortColumn(columnMapping[value]);
        }
    };

    // Function to handle sort order toggle
    const handleSortOrderToggle = () => {
        setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    };

    // Handle back navigation while preserving search state
    const handleUserPageBackNavigation = () => {
        console.log('Back navigation clicked, current search state:', { searchQuery, searchDropValue });
        navigate(-1);
    };

    const handleDelete = async () => {
        await deleteUsers();
    };

    const deleteUsers = async () => {
        try {
            setLoading(true);
            await axios.delete('/admin/user', { data: selected }).then((res) => {
                const isDeletedCount = res?.data?.response?.isDeleted;
                if (isDeletedCount > 0) {
                    setAlertMessage(
                        `${isDeletedCount === res?.data?.totalCount
                            ? `Selected ${isDeletedCount > 1 ? 'users' : 'user'} has been deleted successfully.`
                            : `${isDeletedCount} ${isDeletedCount > 1 ? 'users' : 'user'} out of ${res?.data?.totalCount
                            } has been deleted successfully.`
                        }`
                    );
                    setAlertStatus('success');
                } else {
                    setAlertMessage(`Selected ${isDeletedCount > 1 ? 'users' : 'user'} can't been deleted.`);
                    setAlertStatus('error');
                }
                setIsSnackBarOpen(true);
                fetchUsers();
            });
        } catch (err) {
            setAlertMessage(err?.response?.data?.message);
            setAlertStatus('error');
            setIsSnackBarOpen(true);
        } finally {
            setLoading(false);
            setSelected([]);
        }
    };

    // const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - users.length) : 0;

    const isNotFound = filteredUsers?.length === 0;

    const handleRowClick = (event, id) => {
        console.log('Row clicked, current search state:', { searchQuery, searchDropValue });
        navigate(`/dashboard/user/invoices/${id}`);
    };

    const activateOrDeactivateUser = async (userId, type, checkUser) => {
        setLoading(true);
        try {
            if (checkUser?.isBelowEighteen && checkUser?.isParentalEmailReceived === false) {
                const response = await axios.put(`/admin/user/activate-below-eighteen-user/${userId}`);
                if (response?.data?.statusCode === 200) {
                    setAlertMessage(`User is activated successfully.`);
                    await fetchUsers();
                }
            } else {
                await axios.put(`/admin/user/${userId}?isActive=${type}`).then(async () => {
                    setAlertMessage(`UserId #${userId} has been ${type === 'true' ? 'Activated' : 'Deactivated'} successfully.`);
                    setAlertStatus('success');
                    setAutoHideDuration(2000);
                    setIsSnackBarOpen(true);
                    await fetchUsers();
                    setActivateModal({ show: false });
                });
            }
        } catch (err) {
            setActivateModal({ show: false });
            setAlertMessage(err?.response?.data?.message);
            setAlertStatus('error');
            setIsSnackBarOpen(true);
        } finally {
            setActivateModal({ show: false });
            setLoading(false);
        }
    };

    const getUserDetails = (id) => {
        const user = users.find((users) => users.userId === id);
        setShowUserDetails(user);
        setShowEditModal(true);
        reset({
            userAccountType: (user.accountType === 1 && 'Private Account') || (user.accountType === 2 && 'Business Account'),
            firstName: user?.firstName,
            lastName: user?.lastName,
            email: user?.email,
            ssn: user?.ssn,
            country: user?.country,
            phoneNo: user?.phoneNo,
            dateOfBirth: user?.dateOfBirth,
            city: user?.city,
            address: user?.address,
            zipCode: user?.zipCode,
            incomeTax: user?.incomeTax,
            fakturaFee: user?.fakturaFee,
            organisation: user?.organisation,
            profession: user?.profession,
            accountType: user?.accountType,
        });
    };

    const editUserDetails = async (values) => {
        try {
            setLoading(true);
            await axios.put('/admin/user/edit-employee', {
                ...values,
                id: showUserDetails.userId,
                dateOfBirth: selectedOption === 'DOB' ? values.dateOfBirth : '',
                ssn: selectedOption === 'SSN' ? values.ssn : '',
                accountType: values.userAccountType === 'Private Account' ? 'Contract' : 'Business',
            });
            setShowEditModal(false);
            setAlertMessage('Details has been updated successfully.');
            setAlertStatus('success');
            setAutoHideDuration(3000);
            setIsSnackBarOpen(true);
            await fetchUsers();
        } catch (err) {
            setAlertMessage(err?.response?.data?.message);
            setAlertStatus('error');
            setAutoHideDuration(3000);
            setIsSnackBarOpen(true);
        } finally {
            setLoading(false);
        }
    };

    const editBankDetails = async (values) => {
        try {
            setLoading(true);
            const response = await axios.put('/admin/user/update-bankdetails', {
                id: selectedUser.customerSalaryInformation[0]?.id,
                userId: selectedUser.userId,
                bank: values.chooseBankName === 'Other banks' ? values.createBankName : chooseBankName,
                bicNumber: values.bicNumber || '',
                ibanNumber: values.ibanNumber || '',
                accountNumber: values.accountNumber || '',
                clearingNumber: values.clearingNumber || '',
            });
            setBankName('');
            setChooseBankName('');
            resetForm2({ bankDetails: {} });
            setIsOpenModal({ bankDetails: false });
            setAlertMessage(response?.data.message);
            setAlertStatus('success');
            setAutoHideDuration(3000);
            setIsSnackBarOpen(true);
            await fetchUsers();
        } catch (err) {
            setAlertMessage(err?.response?.data?.message);
            setAlertStatus('error');
            setAutoHideDuration(3000);
            setIsSnackBarOpen(true);
        } finally {
            setLoading(false);
        }
    };

    const newDetails = [];

    Object.keys(countries.countries).forEach((code) => {
        // if (countries.countries[code].continent === 'EU') {
        newDetails.push({ label: countries.countries[code].name });
        // }
    });

    const handleSnackBarClose = () => {
        setIsSnackBarOpen(false);
    };

    const handleOpenModal = (id) => {
        setIsOpenModal({ bankDetails: true });
        const filteredUser = filteredUsers.find((u) => u.userId === id);

        resetForm2({
            bankDetails: {
                chooseBankName,
                createBankName: filteredUser.customerSalaryInformation[0]?.bank,
                bicNumber: filteredUser.customerSalaryInformation[0]?.bicNumber,
                ibanNumber: filteredUser.customerSalaryInformation[0]?.ibanNumber,
                clearingNumber: filteredUser.customerSalaryInformation[0]?.clearingNumber,
                accountNumber: filteredUser.customerSalaryInformation[0]?.accountNumber,
            },
        });
        setSelectedUser(filteredUser);
    };

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };

    const handleChange = (event) => {
        const {
            target: { value },
        } = event;
        setPersonName(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value
        );
    };

    const onSendEmail = () => {
        const selectedUsers = users.filter((item) => selected.includes(item.userId));
        setPersonName(selectedUsers?.map((item) => item.email));
        setIsOpenModal({ sandEmail: true });
    };

    const handleSendEmail = async (e) => {
        e.preventDefault();
        try {
            setIsOpenModal(false);
            const response = await axios.post('/adminemailtemplate/email', {
                ...templateData,
                toEmails: personName,
            });
            setAlertStatus('success');
            setAlertMessage(response?.data.response);
            setAutoHideDuration(3000);
            setIsSnackBarOpen(true);
        } catch (err) {
            setAlertStatus('error');
            if (err.response.data) {
                setAlertMessage(err?.response?.data?.message);
            } else {
                setAlertMessage(err.message);
            }
            setAutoHideDuration(3000);
            setIsSnackBarOpen(true);
        }
    };

    const handleEmailType = (e) => {
        const value = e.target.value;
        setemailType(value);
    };

    const handleSendAllEmails = async (type) => {
        try {
            if (!templateData?.Subject || !templateData?.templateFromName) {
                return toast.error('Please fill emails fields.');
            }

            setIsOpenModal(false);
            setemailType(null);
            const response = await axios.post(`/adminemailtemplate/send-email-allusers?type=${type}`, {
                ...templateData,
                toEmails: personName,
            });

            if (response?.data?.response) {
                toast.success(response?.data?.response);
            } else {
                toast.error(response?.data);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message);
        }
    };

    useEffect(() => {
        if (emailType !== null) {
            if (emailType === 1) {
                handleSendAllEmails(1);
            } else if (emailType === 2) {
                handleSendAllEmails(2);
            } else {
                handleSendAllEmails(3);
            }
        }
    }, [emailType]);

    useEffect(() => {
        if (watch('emailTemplate.selectedTemplate')) {
            const removedDuplicate = [];
            const userData = watch('emailTemplate.selectedTemplate')?.emailTemplateUserList;
            if (selected?.length > 0) {
                const selectedUsers = users.filter((item) => selected.includes(item.userId));
                const allEmails = [
                    ...userData?.map((item) => item.signUpUser.email),
                    ...selectedUsers?.map((item) => item.email),
                ];
                removedDuplicate.push(...allEmails.filter((item, index) => allEmails.indexOf(item) === index));
            }
            setTemplateData(() => ({
                content: watch('emailTemplate.selectedTemplate')?.html,
                Subject: watch('emailTemplate.selectedTemplate')?.templateSubject,
                templateFromName: watch('emailTemplate.selectedTemplate')?.templateFromName,
            }));
            setPersonName(removedDuplicate?.length > 0 ? removedDuplicate : userData?.map((item) => item?.signUpUser?.email));
        }
    }, [watch('emailTemplate.selectedTemplate')]);

    const handleBankChange = (event) => {
        setChooseBankName(event.target.value);
    };

    // Bank Name select
    useEffect(() => {
        if (Object.keys(selectedUser)?.length > 0) {
            setBankName(Object.keys(selectedUser)?.length > 0 ? selectedUser.customerSalaryInformation[0]?.bank : '');
            setChooseBankName(
                banksData.some((item) => item.description === bankName) || !bankName ? bankName : 'Other banks'
            );
        }
    }, [selectedUser, bankName]);

    // Add Notes
    const addnoteToggle = (id) => {
        setToggleNote(true);
        setSelectedUserId(id);
        setNoteType('General');
        setSurveyNotes([]);
        setSurveyRatings({});
        const filteredUser = filteredUsers.find((u) => u.userId === id);
        resetForm3({
            description: '',
        });
        setSelectedUser(filteredUser);
    };

    const postAddnotes = async () => {
        try {
            if (notesContent === '' || notesContent.trim() === '') {
                setIsNotesContentEmpty(true);
                setNotesContent('');
            } else {
                setIsNotesContentEmpty(false);
                setLoading(true);
                const response = await axios.post('/admin/user/notes', {
                    userId: selectedUser?.userId,
                    invoiceNumber: 0,
                    description: notesContent,
                    notesType: noteType === "General" ? 1 : noteType === "Economic" ? 7 : null,
                });

                if (response?.status === 200) {
                    setLoading(false);
                    fetchCommentList();
                    setNotesContent('');
                    toast.success('Notes added successfully');
                    fetchUsers();
                } else {
                    setLoading(false);
                    toast.error('Server Error! Please try again');
                }
            }
        } catch (err) {
            setLoading(false);
            if (err?.response?.data) {
                toast.error(err?.response?.data?.message);
            } else {
                toast.error(err?.message);
            }
            setAlertStatus('error');
        } finally {
            setLoading(false);
        }
    };

    const fetchCommentList = async () => {
        try {
            setLoading(true);
            const res = await axios.get(`admin/user/get-notes?userId=${selectedUser?.userId}`);
            setcommentList(res?.data?.response);
        } catch (err) {
            setcommentList([]);
        } finally {
            setLoading(false);
        }
    };

    const handleSendLink = async (data) => {
        const { userId } = data?.row;
        try {
            setLoading(true);
            const url = `/admin/user/send-verifymail-to-customer`;
            const response = await axios.post(url, [userId]);
            if (response?.data?.message === 'Success') {
                setAlertMessage('Email sent successfully');
                setAlertStatus('success');
                setIsSnackBarOpen(true);
                setisSendLink({
                    show: false,
                });
            } else {
                throw new Error(response?.data?.message || 'Unexpected error');
            }
        } catch (err) {
            setAlertMessage(err?.response?.data?.message || err.message);
            setAlertStatus('error');
            setIsSnackBarOpen(true);
        } finally {
            setLoading(false);
        }
    };

    const [toggleuserInfo, settoggleuserInfo] = useState(false);
    const [getDeactivateduserInfo, setgetDeactivateduserInfo] = useState(null);
    const getDeactivatedNotes = async (userId) => {
        try {
            setLoading(true);
            const response = await axios.get(`/admin/user/get-notes?userId=${userId}&IsPermanentDeativatedNote=true`);
            setgetDeactivateduserInfo(response?.data?.response);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.log(error);
        }
    };

    const getUserDetailsInfo = (id) => {
        settoggleuserInfo(true);
        getDeactivatedNotes(id);
    };

    const handlePermanentDeactivateUser = async (e, userId) => {
        e.preventDefault();
        try {
            const trimmedReason = reasonForDeactivated.trim();
            if (trimmedReason === '') {
                setisReasonEmpty(true);
            } else {
                setLoading(true);
                setisReasonEmpty(false);
                const result = await axios.put(`/admin/user/permanent-deactivate-user/${userId}?description=${trimmedReason}`);
                if (result?.data?.statusCode === 200) {
                    toast.success('User is deactivated successfully.');
                    setpermanentDeactivate(false);
                    setLoading(false);
                    setreasonForDeactivated('');
                    await fetchUsers();
                }
            }
        } catch (error) {
            if (error?.response?.status === 500) {
                toast.error('Fortnox error occurred. Please refresh and try again.');
            } else {
                toast.error(error?.message);
            }
            setLoading(false);
        }
    };

    useEffect(() => {
        if (toggleNote) {
            fetchCommentList();
        }
    }, [toggleNote, selectedUser]);

    const downloadData = async (userId) => {
        setLoading(true);
        try {
            const filteredUser = filteredUsers.find((u) => u.userId === userId);
            setGetUserId(filteredUser?.userId);

            const res = await axios.get(`admin/adminsalary/yearly-hours?id=${userId}&year=${selectedYear}`);
            if (res?.status === 200) {
                setLoading(false);

                setincomeData({
                    values: res?.data?.response,
                    statusCode: res?.status,
                });
            } else {
                toast.error('Server Error! Please try again');
            }
        } catch (error) {
            setLoading(false);
            toast.error(error?.response?.data?.message);
        }
    };

    const boxStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };

    const commentStyle = {
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        width: '60%',
        height: '80%',
        // overflow: 'scroll',
        marginBottom: '40',
        p: 3,
    };

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };

    const handleDeleteUser = async (userId) => {
        try {
            setLoading(true);
            const response = await axios.delete(`/admin/user/delete-user/${userId}`);
            if (response?.data?.statusCode === 200) {
                toast.success(response?.data?.response || "User deleted successfully.");
                await fetchUsers();
            } else {
                toast.error('Server Error! Please try again');
            }
        } catch (err) {
            setDeleteUserModal({ show: false });
            toast.error(err?.response?.data?.message);
            setLoading(false);

        } finally {
            setDeleteUserModal({ show: false });
            setLoading(false);
        }
    };

    const handleChangeStatusOfDeactivate = async () => {
        try {
            setLoading(true);
            const response = await axios.post(`admin/user/permanent-reactivate-user/${accidentalReactivate?.userId}`);
            if (response.data?.statusCode === 200) {
                setLoading(false);
                toast.success('User is reactivated successfully');
                setaccidentalReactivate({
                    show: false,
                });
                await fetchUsers();
            }
        } catch (error) {
            toast.error(error?.response?.data?.message);
            setLoading(false);
        }
    };

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);
        if (selectedOption === 'SSN') {
            resetField('dateOfBirth', { defaultValue: '' });
        } else if (selectedOption === 'DOB') {
            resetField('ssn', { defaultValue: '' });
        }
    };

    useEffect(() => {
        if (showUserDetails?.dateOfBirth === '' || showUserDetails?.dateOfBirth === null) {
            setSelectedOption('SSN'); // Select SSN
        } else if (showUserDetails?.dateOfBirth && showUserDetails?.ssn) {
            setSelectedOption('SSN');
        } else if (showUserDetails?.ssn === '' || showUserDetails?.ssn === null) {
            setSelectedOption('DOB'); // Select DOB
        }
    }, [showUserDetails]);

    const renderUsers = () => (
        <>
            <ListToolbar
                onDelete={handleDelete}
                onFilter={handleFilter}
                onSendEmail={onSendEmail}
                searchQuery={searchQuery}
                numSelected={selected?.length}
                hideDeleteButton={selectedTabValue !== '3' && 'true'}
                dropOptions={loyaltyDropOptions}
                searchDropValue={searchDropValue}
                setSearchDropValue={handleSetSearchDropValue}
                sortOrder={sortOrder}
                sortColumn={sortColumn}
                onSortOrderToggle={handleSortOrderToggle}
            />
            <Scrollbar>
                <TableContainer sx={{ minWidth: 800 }}>
                    <Table className={`${selectedTabValue === '5' ? '' : 'user-table'}`}>
                        <ListHead
                            order={order}
                            orderBy={orderBy}
                            headLabel={selectedTabValue !== '5' ? TABLE_HEAD : deactivatedHead}
                            rowCount={users?.length}
                            numSelected={selected?.length}
                            onRequestSort={handleRequestSort}
                            onSelectAllClick={handleSelectAllClick}
                            hideCheckboxColumnHeader={selectedTabValue === '5' ? true : false}
                        />
                        <TableBody>
                            {(originalUsers?.length &&
                                originalUsers?.map((row) => {
                                    const {
                                        userId,
                                        firstName,
                                        lastName,
                                        email,
                                        userLoyaltyStatus,
                                    } = row;

                                    const isItemSelected = selected.indexOf(userId) !== -1;
                                    return (
                                        <>

                                            <TableRow
                                                key={userId}
                                                tabIndex={-1}
                                                role="checkbox"
                                                selected={isItemSelected}
                                                aria-checked={isItemSelected}
                                                style={{
                                                    backgroundColor: row?.isSelected ? 'lightgrey' : '',
                                                    cursor: 'pointer',
                                                }}
                                            >
                                                <TableCell padding="checkbox">
                                                    <Checkbox
                                                        checked={isItemSelected}
                                                        onChange={(event) => handleClick(event, userId)}
                                                        onClick={(event) => event.stopPropagation()}
                                                        size="small"
                                                    />
                                                </TableCell>

                                                <TableCell
                                                    align="left"
                                                    style={{ fontSize: '13px', padding: '6px' }}
                                                >
                                                    {userId}
                                                </TableCell>
                                                {`${firstName} ${lastName}`?.length >= 18 ? (
                                                    <Tooltip title={`${firstName} ${lastName}`} arrow placement="top">
                                                        <TableCell
                                                            align="left"

                                                            style={{ fontSize: '13px', padding: '6px' }}
                                                        >
                                                            {`${firstName} ${lastName}`?.substring(0, 18).concat('...')}
                                                        </TableCell>
                                                    </Tooltip>
                                                ) : (
                                                    <TableCell
                                                        align="left"
                                                        className="userColumn"
                                                    >
                                                        {`${firstName} ${lastName}`}
                                                    </TableCell>
                                                )}

                                                <TableCell
                                                    align="left"
                                                    className="userColumn"

                                                >
                                                    {email}
                                                </TableCell>

                                                {/* <TableCell
                                                        align="left"
                                                        className="userColumn"
                                                        onClick={(event) => handleRowClick(event, userId)}
                                                    >
                                                        {invoiceCount}
                                                    </TableCell> */}


                                                <TableCell align="left" style={{ fontSize: '13px', padding: '6px' }}>
                                                    {userLoyaltyStatus ? userLoyaltyStatus.userCurrentRoyaltyPoints.toLocaleString() : 0}
                                                </TableCell>

                                                <TableCell align="left" style={{ fontSize: '13px', padding: '6px' }}>
                                                    {userLoyaltyStatus ?
                                                        userLoyaltyStatus.userCurrentLoyaltyTier == 2 ? 'Bronze' :
                                                            userLoyaltyStatus.userCurrentLoyaltyTier == 3 ? 'Silver' :
                                                                userLoyaltyStatus.userCurrentLoyaltyTier == 4 ? 'Gold' :
                                                                    userLoyaltyStatus.userCurrentLoyaltyTier == 5 ? 'Platinum' : 'Iron'
                                                        : 'Iron'}
                                                </TableCell>

                                                <TableCell align="left" style={{ padding: '6px' }}>
                                                    <Tooltip title="View User Details">
                                                        <Button
                                                            variant="contained"
                                                            onClick={() => {
                                                                navigate(`/dashboard/loyalty-dashboard/user/${userId}`);
                                                            }}
                                                            style={{
                                                                width: 50,
                                                                minWidth: '50px',
                                                                fontSize: '12px',
                                                            }}
                                                        >
                                                            View
                                                        </Button>
                                                    </Tooltip>
                                                </TableCell>
                                            </TableRow>

                                        </>
                                    );
                                })) ||
                                ''}









                        </TableBody>
                        {isNotFound && (
                            <TableBody>
                                <TableRow>
                                    <TableCell align="center" colSpan={12} sx={{ py: 3 }}>
                                        <SearchNotFound searchQuery={searchQuery} />
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        )}
                    </Table>
                </TableContainer>
            </Scrollbar>



            {/* Add Notes  Modal */}



            {/* get Deactivated data */}





            <MultipleUsersPDF openPDFModal={openPDFModal} setOpenPDFModal={setOpenPDFModal} selectedUserId={selected} />

            <TablePagination
                rowsPerPageOptions={[100, 250, 500]}
                component="div"
                count={totalCount}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </>
    );

    const handleTabChange = (e, newValue) => {
        // Only clear search if the tab is actually changing (not on initial render)
        if (selectedTabValue !== newValue) {
            dispatch(clearSearch());
        }
        setPage(0);
        setSelected([]);
        dispatch(setReduxSelectedTabValue(newValue));
        setAllSelected(false);
    };

    return (
        <Page title="User">
            {(loading || isLoading) && <Loader />}
            <Container>

                <Snackbar
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    open={isSnackBarOpen}
                    autoHideDuration={autoHideDuration}
                    onClose={handleSnackBarClose}
                >
                    <Alert onClose={handleSnackBarClose} severity={alertStatus} sx={{ width: '100%' }}>
                        {alertMessage}
                    </Alert>
                </Snackbar>
                <Card>
                    <Box sx={{ width: '100%', typography: 'body1' }}>
                        <TabContext value={selectedTabValue}>
                            {/* <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                <TabList onChange={(e, newValue) => handleTabChange(e, newValue)} aria-label="lab API tabs example">
                                    <Tab label="ACTIVE" value="2" />
                                    <Tab label="INACTIVE" value="3" />
                                    <Tab label="ALL" value="1" />
                                    <Tab label="PASSIVE" value="4" />
                                    <Tab label="PERMANENT DEACTIVATED USERS" value="5" />
                                </TabList>
                            </Box> */}
                            <TabPanel value="1" sx={{ padding: 0 }}>
                                {renderUsers()}
                            </TabPanel>
                            <TabPanel value="2" sx={{ padding: 0 }}>
                                {renderUsers()}
                            </TabPanel>
                            <TabPanel value="3" sx={{ padding: 0 }}>
                                {renderUsers()}
                            </TabPanel>
                            <TabPanel value="4" sx={{ padding: 0 }}>
                                {renderUsers()}
                            </TabPanel>
                            <TabPanel value="5" sx={{ padding: 0 }}>
                                {renderUsers()}
                            </TabPanel>
                        </TabContext>
                    </Box>
                </Card>
            </Container>
        </Page>
    );
}
